import { render, staticRenderFns } from "./OrdenSalida.vue?vue&type=template&id=7c86c0bf&scoped=true"
import script from "./OrdenSalida.vue?vue&type=script&lang=js"
export * from "./OrdenSalida.vue?vue&type=script&lang=js"
import style0 from "./OrdenSalida.vue?vue&type=style&index=0&id=7c86c0bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c86c0bf",
  null
  
)

export default component.exports